import DashboardLayout from "@/views/LayoutView/DashboardLayout.vue";

import FinalReviewStatus from "@/views/FinalReviewView/FinalReviewStatus.vue";
import CompletedFinalReview from "@/views/FinalReviewView/CompletedFinalReview.vue";
import ShowFinalReview from "@/views/FinalReviewView/ShowFinalReview.vue";
import EditFinalReview from "@/views/FinalReviewView/EditFinalReview.vue";

const finalReviewsMenu = {
  path: "/final-reviews",
  component: DashboardLayout,
  name: "Final Reviews",
  children: [
    {
      path: "status",
      name: "final-review-status",
      component: FinalReviewStatus,
      meta: { requiresAuth: true, requiredRoles: ["editor", 'master'], title: "총평 관리 > 총평 현황" },
    },
    {
      path: "done",
      name: "final-review-done",
      component: CompletedFinalReview,
      meta: { requiresAuth: true, requiredRoles: ["editor", 'master'], title: "총평 관리 > 완료" },
    },
    {
      path: "detail/:idx?",
      name: "final-review-detail",
      props: true,
      component: ShowFinalReview,
      meta: { requiresAuth: true, requiredRoles: ["editor", 'master'], title: "총평 관리 > 총평 내용" },
    },
    {
      path: "edit/:idx?",
      name: "final-review-edit",
      component: EditFinalReview,
      props: true,
      meta: { requiresAuth: true, requiredRoles: ["editor", 'master'], title: "총평 관리 > 총평하기" },
    },
  ],
};

export default finalReviewsMenu;
